export const SOCKET_MESSAGE = {
  UPDATE_GPS: 'sendGPS',
  FETCH_MEMES: 'sendMemes',
  CREATE_MEME: 'createMeme',
  CONNECT: 'connect',
}